import { RESET_STATE, TOGGLE_DRAWER, ACTION_LOGOUT_INITIATED } from '../actions/types';

const initialState = {
	isOpen: false,
};

export default function (state = initialState, action) {
	switch (action.type) {
		case RESET_STATE:
			return initialState;

		case TOGGLE_DRAWER:
			return {
				...state,
				isOpen: action.payload,
			};
				
		case ACTION_LOGOUT_INITIATED:
			return initialState;
		
		default:
			return state;
	}
}
